import lodash from 'lodash'

export default{
  getListLibrary (state, payload) {
    state.libraries = payload
  },
  destroy (state, payload) {
    var index = lodash.findIndex(state.libraries, ['id', payload.id])
    state.libraries.splice(index, 1)
  },
  getListTrash (state, payload) {
    state.librariesTrash = payload
  },
  restore (state, payload) {
    var index = lodash.findIndex(state.librariesTrash, ['id', payload.id])
    state.librariesTrash.splice(index, 1)
    state.libraries.push(payload)
  },
  destroyPermanently (state, payload) {
    var index = lodash.findIndex(state.librariesTrash, ['id', payload.id])
    state.librariesTrash.splice(index, 1)
  },
  getLibraryDoc (state, payload) {
    state.librariesDoc = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/module/library/mutations.js